var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2648 1.5L20.6253 5.38889C21.0476 13.2742 19.1323 17.1435 12.2648 22.5C10.6681 21.2555 9.33332 20.098 8.22406 18.9438C12.5187 17.2795 14.5251 15.6493 16.5426 12.7777C13.3888 15.1475 11.1686 16.57 6.99219 17.5467C6.19468 16.5515 5.55113 15.5343 5.03896 14.4428C10.7502 13.4155 14.1482 10.8961 15.7649 8.77776C15.5997 8.87315 15.429 8.97306 15.2521 9.07657L15.2521 9.07658C13.034 10.3748 9.84946 12.2388 4.39193 12.8208C4.08726 11.9075 3.85553 10.9342 3.6861 9.87658C7.60127 8.98064 9.63939 8.10357 11.876 6.55554C9.52526 7.57707 7.64952 8.17237 3.50743 8.52228C3.40474 7.55243 3.34459 6.5131 3.32031 5.38889L12.2648 1.5Z",
    fill: "url(#paint0_linear_9013_9230)",
    fillOpacity: 0.78
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9013_9230",
    x1: 20.8203,
    y1: 5.58333,
    x2: 0.0147569,
    y2: 5.58333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E8345",
    stopOpacity: 0.33
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLogo);
export default __webpack_public_path__ + "static/media/blue-logo.64cd1042597186a27de4a93cb6233ae8.svg";
export { ForwardRef as ReactComponent };